import { connect } from 'react-redux';
import ListAll from "./ListAll";

import { fetchArticles } from '../service/articles';
import { articlesReceived, clearArticles } from '../store';

const mapStateToProps = (state) => ({
    articles: state.articles.list,
    totalPages: state.articles.totalPages
});

const mapDispatchToProps = dispatch => ({
    loadArticles: page => (
        fetchArticles(page)
            .then(list => {
                dispatch(articlesReceived(list.articles, list.pagination.totalPages));
                return true;
            })
            .catch(e => {
                console.error(e);
                return false;
            })
    ),
    clearArticles: () => dispatch(clearArticles())
});

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(ListAll);



// WEBPACK FOOTER //
// ./src/components/ListAll.container.js